// removed by extract-text-webpack-plugin
module.exports = {"pShowList":"pShowList___1kJVB","listShowList":"listShowList___12ZbH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/List.module.scss
// module id = 2322
// module chunks = 0